import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api from "@/lib/api";

const money = (n) => (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

// Safe date-only formatting (avoids UTC shift from new Date on YYYY-MM-DD)
function fmtDate(iso) {
  if (!iso || typeof iso !== "string" || iso.length < 10) return "";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
}

export default function RecapsListSection() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.get("/employee/recaps-list")
      .then((res) => { if (active) setData(res.data); })
      .catch(() => { if (active) setData(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  if (loading || !data || !data.recaps || data.recaps.length === 0) return null;

  return (
    <div className="earnings-body" style={{ paddingTop: 12, paddingBottom: 0 }} data-testid="recaps-list-section">
      <div style={{ background: "#F3EEE7", borderRadius: 14, padding: 20 }}>
        <div style={{ fontFamily: "Cormorant, serif", fontSize: 22, color: "#231E1A", marginBottom: 2 }}>Past paydays</div>
        <div style={{ fontSize: 13, color: "#9C6B4A", marginBottom: 14 }}>Every recap, saved for you — {data.count} paydays</div>
        <div>
          {data.recaps.map((r) => (
            <div key={r.period_id} data-testid={`recap-item-${r.period_id}`}
              onClick={() => navigate(`/employee/payday-recap/${r.period_id}`)}
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "14px 0", borderTop: "1px solid #EAE1D4", cursor: "pointer" }}>
              <div>
                <div style={{ fontSize: 15, color: "#231E1A", fontWeight: 500 }}>{(r.paid_check_dates || [r.check_date]).map(fmtDate).join(" & ")}</div>
                <div style={{ fontSize: 12.5, color: "#9C6B4A" }}>{fmtDate(r.start_date)} – {fmtDate(r.end_date)}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontFamily: "Cormorant, serif", fontSize: 20, color: "#231E1A", fontWeight: 600 }}>${money(r.gross_pay)}</span>
                <ChevronRight size={18} color="#B0905E" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
